import { useState } from "react";
import {
    Button,
    Popover,
    PopoverHandler,
    PopoverContent,
    Typography,
} from "@material-tailwind/react";
import {
    ClockIcon,
    ExclamationTriangleIcon,
} from "@heroicons/react/24/solid";
import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const priorityStyles = {
    high: "text-red-600",
    medium: "text-yellow-600",
    low: "text-green-600",

};

export default function RfqDeadlinePopover({ rfq_data }) {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation('rfq');

    const { user } = useSelector((state) => state.user);

    const assigned_user =
        rfq_data?.assigned_details?.find((item) => item.assigned_to_id === user?.id) ||
        rfq_data?.assigned_details?.[0];


    const getTimeSlotStatus = (toTime) => {
        if (!toTime) return { color: "text-gray-500", text: t('na'), delayed: "" };

        const now = moment();
        const end = moment(toTime);
        const isDelayed = now.isAfter(end);

        let delayedText = "";
        if (isDelayed) {
            const days = now.diff(end, 'days');
            const hours = now.diff(end, 'hours') % 24;

            if (days > 0) {
                delayedText = ` (${days} ${days === 1 ? t('day_delayed') : t('days_delayed')})`;
            } else if (hours > 0) {
                delayedText = ` (${hours} ${hours === 1 ? t('hour_delayed') : t('hours_delayed')})`;
            } else {
                delayedText = ` (${t('delayed')})`;
            }
        }

        return {
            color: isDelayed ? "text-red-500" : "text-green-500",
            delayed: delayedText
        };
    };


    return (<>
        {assigned_user &&
            <Popover open={open} handler={setOpen} placement="bottom-end">
                {/* Trigger Button */}
                {/* <PopoverHandler>
                    <Button variant="outlined" className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-green-300 text-white">
                        {t('view_deadline_button')}
                        <ClockIcon className="w-4 h-4" /></Button>
                </PopoverHandler> */}

                {/* Popover Content (Only Info) */}
                <PopoverContent className="w-100 p-5 rounded-2xl shadow-lg bg-white border border-gray-200">
                    <div className="space-y-4">

                        {/* Header */}
                        <Typography variant="h6" className="font-bold text-gray-900">
                            {t('deadline_details_title')}
                        </Typography>

                        {/* Info Box */}
                        <div className="bg-gray-50 rounded-xl border p-4 space-y-3">

                            <div className="flex justify-between items-center gap-10">
                                <span className="text-gray-700 font-medium">{t('timeslot_label')}</span>

                                <div className="text-sm font-medium">
                                    {(user?.roles[0] === 'Sub Admin' || user?.roles[0] === 'Administrator' || user?.roles[0] === 'Finance') ? (
                                        <span className="text-gray-500">
                                            {assigned_user?.deadline
                                                ? `${t('deadline_label')}: ${moment(assigned_user.deadline).format("D MMM | h:mm A")}`
                                                : t('na')}
                                        </span>
                                    ) : (
                                        (() => {
                                            const from = assigned_user?.timeslot?.from;
                                            const to = assigned_user?.timeslot?.to;
                                            const status = getTimeSlotStatus(to);

                                            return (
                                                <span className={status.color}>
                                                    {from && to
                                                        ? `${moment(from).format("D MMM | h:mm A")} - ${moment(to).format("D MMM | h:mm A")}`
                                                        : t('na')}
                                                    {status.delayed && <span className="ml-1">{status.delayed}</span>}
                                                </span>
                                            );
                                        })()
                                    )}
                                </div>
                            </div>
                            <div className="flex justify-between items-center">
                                <span className="text-gray-700 font-medium">{t('priority_label')}</span>

                                <span className={`flex items-center gap-2 font-bold ${priorityStyles[assigned_user?.priority]}`}>
                                    {assigned_user?.priority?.charAt(0).toUpperCase() + assigned_user?.priority?.slice(1)}
                                    <ExclamationTriangleIcon className={`w-4 h-4 ${priorityStyles[assigned_user?.priority]}`} />
                                </span>

                            </div>
                        </div>

                        {/* Note */}
                        {assigned_user?.notes && <div className="p-3 bg-red-50 rounded-xl border border-red-200 text-sm text-red-700 leading-relaxed">
                            <strong className="font-semibold">{t('note_label')}:</strong>
                            {assigned_user?.notes}
                        </div>}

                    </div>
                </PopoverContent>
            </Popover>
        }
    </>
    );
}
